module.exports = __webpack_public_path__ + "static/media/bar.83257ad1.jpg";